import styled from "styled-components";

const c = {
  black: "#1e1e1e",
  white: "#ffffff",

  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.22)",

  pink: "#fc9ac4",
  pinkStrong: "#ff77b4",
  pinkSoft: "rgba(252,154,196,0.16)",

  ink: "rgba(0,0,0,0.86)",
  inkSoft: "rgba(0,0,0,0.66)",
};

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.52);
  backdrop-filter: blur(6px);

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 5000;
  padding: 18px;
`;

export const ModalContent = styled.div`
  background: rgba(255, 255, 255, 0.98);
  border-radius: 18px;

  border: 1px solid rgba(201, 162, 39, 0.35);
  box-shadow:
    0 30px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(252, 154, 196, 0.14);

  position: relative;
  max-width: 440px;
  width: 100%;

  text-align: center;
  padding: 22px 22px 18px;

  &::before {
    content: "";
    position: absolute;
    left: 16px;
    right: 16px;
    top: 14px;
    height: 1px;
    background: rgba(201, 162, 39, 0.65);
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;

  width: 38px;
  height: 38px;
  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  background: rgba(30, 30, 30, 0.06);
  border: 1px solid rgba(201, 162, 39, 0.25);

  color: ${c.pinkStrong};
  font-size: 22px;
  line-height: 1;
  font-weight: 800;

  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(252, 154, 196, 0.75);
    background: rgba(252, 154, 196, 0.08);
    color: ${c.pinkStrong};
  }

  &:active {
    transform: translateY(0px);
  }
`;

export const ToastText = styled.p`
  margin: 18px 0 0 0;

  font-family: "Cormorant Garamond", serif;
  font-size: 18px;
  letter-spacing: 0.02em;

  color: ${c.ink};

  position: relative;
  padding-bottom: 14px;

  &::after {
    content: "";
    position: absolute;
    left: 22%;
    right: 22%;
    bottom: 2px;
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      rgba(201, 162, 39, 0),
      rgba(201, 162, 39, 0.55),
      rgba(252, 154, 196, 0.7),
      rgba(201, 162, 39, 0.55),
      rgba(201, 162, 39, 0)
    );
    opacity: 0.85;
  }
`;
